import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";

const TESTIMONIALS = [
    {
        quote: "Rodney took what was in my head and made it real. People mention the website now before they mention anything else.",
        name: "Pastor D.",
        role: "Ministry & Church",
        initials: "PD",
        tilt: "-1.2deg",
    },
    {
        quote: "Our old site embarrassed us. The new one books calls while I'm with clients. Best money I've spent on the business.",
        name: "Marcus D.",
        role: "Small Business Owner",
        initials: "MD",
        tilt: "0.9deg",
    },
    {
        quote: "Fast, professional, and it actually looks like me. My podcast and coaching finally have a home I'm proud to share.",
        name: "Alisha R.",
        role: "Coach & Creator",
        initials: "AR",
        tilt: "-0.8deg",
    },
];

const Card = ({ t, i }) => (
    <motion.figure
        data-testid={`testimonial-card-${i}`}
        className="group relative border-2 border-[#0A0F1D] bg-white p-7 shadow-[8px_8px_0_rgba(0,102,255,0.85)] transition-[box-shadow,transform] duration-300 hover:-translate-y-1.5 hover:shadow-[12px_12px_0_rgba(0,102,255,1)] sm:p-8"
        style={{ rotate: t.tilt }}
        initial={{ opacity: 0, y: 44 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay: i * 0.14, ease: [0.22, 1, 0.36, 1] }}
        whileHover={{ rotate: "0deg" }}
    >
        <Quote className="absolute -top-4 left-6 h-8 w-8 rounded-full bg-[#0066FF] p-1.5 text-white shadow-[0_0_20px_rgba(0,102,255,0.45)]" aria-hidden="true" />
        <div className="flex gap-1 pt-2" aria-label="5 out of 5 stars">
            {[0, 1, 2, 3, 4].map((s) => (
                <Star key={s} className="h-4 w-4 fill-[#0066FF] text-[#0066FF]" />
            ))}
        </div>
        <blockquote className="mt-5 text-base leading-relaxed text-slate-700">
            &ldquo;{t.quote}&rdquo;
        </blockquote>
        <figcaption className="mt-7 flex items-center gap-4 border-t border-[#0A0F1D]/10 pt-5">
            <span
                className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-sky-400 to-[#0066FF] font-display text-sm text-white shadow-[3px_3px_0_rgba(10,15,29,0.9)]"
                aria-hidden="true"
            >
                {t.initials}
            </span>
            <span>
                <span className="block font-display text-sm tracking-wide text-[#0A0F1D]">{t.name}</span>
                <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">{t.role}</span>
            </span>
        </figcaption>
    </motion.figure>
);

export const Testimonials = () => (
    <section id="testimonials" className="relative py-24 md:py-36" data-testid="testimonials-section">
        <div className="absolute left-1/2 top-0 h-px w-2/3 -translate-x-1/2 bg-gradient-to-r from-transparent via-[#0066FF]/40 to-transparent" aria-hidden="true" />
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap items-end justify-between gap-6">
                <div>
                    <Reveal>
                        <Eyebrow>Proof</Eyebrow>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="mt-6 font-display text-4xl tracking-tight text-[#0A0F1D] sm:text-5xl lg:text-6xl">
                            CLIENTS SAY<br />IT <span className="text-electric-grad">BEST.</span>
                        </h2>
                    </Reveal>
                </div>
                <Reveal delay={0.2}>
                    <p className="max-w-sm text-sm leading-relaxed text-slate-600 sm:text-base">
                        Real words from people who had a vision — and watched it go online.
                    </p>
                </Reveal>
            </div>

            <div className="mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
                {TESTIMONIALS.map((t, i) => (
                    <Card key={t.name} t={t} i={i} />
                ))}
            </div>
        </div>
    </section>
);
